import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dlg-not-enough-access-keys',
    templateUrl: './dlg-not-enough-access-keys.component.pug',
    styleUrls: ['./dlg-not-enough-access-keys.component.less'],
})
export class DlgNotEnoughAccessKeysComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<DlgNotEnoughAccessKeysComponent>,

        @Inject(MAT_DIALOG_DATA) public data: any,
    ) { }

    ngOnInit() {
    }

    onContinue() {
        this.dialogRef.close(true);
    }

    onCancel() {
        this.dialogRef.close(false);
    }

    onClose() {
        this.dialogRef.close();
    }

}
